<template>
  <div class="login-container">
    <div class="login-box">
      <!-- 左侧插图区域 -->
      <div class="login-illustration">
        <div class="logo">
          <img src="../assets/logo.png" alt="博亿购" />
        </div>
      </div>
      <!-- 右侧注册表单区域 -->
      <div class="login-form">
        <h2 class="login-title">欢迎注册博亿购!</h2>
        <!-- 注册表单 -->
        <el-form :model="registerForm" ref="registerForm" class="form" :rules="registerRules">
          <el-form-item prop="phone">
            <el-input v-model="registerForm.phone" placeholder="请输入手机号" size="large" prefix-icon="el-icon-mobile"
              maxlength="11"></el-input>
          </el-form-item>
          <el-form-item prop="verifyCode">
            <el-input v-model="registerForm.verifyCode" placeholder="验证码" size="large" prefix-icon="el-icon-message"
              maxlength="4">
              <template slot="append">
                <get-verify-code :phone="registerForm.phone" :code-type="'1'"></get-verify-code>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="registerForm.password" :type="passwordType" placeholder="密码" size="large"
              prefix-icon="el-icon-lock" maxlength="12"></el-input>
            <img src="~@/assets/images/60.png" alt="隐藏密码" v-if="passwordType == 'password'" class="show-pwd"
              @click="showPwd" />
            <img src="~@/assets/images/61.png" alt="显示密码" v-else class="show-pwd" @click="showPwd" />
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input v-model="registerForm.confirmPassword" :type="passwordType" placeholder="确认密码" size="large"
              prefix-icon="el-icon-lock" maxlength="12"></el-input>
            <img src="~@/assets/images/60.png" alt="隐藏密码" v-if="passwordType == 'password'" class="show-pwd"
              @click="showPwd" />
            <img src="~@/assets/images/61.png" alt="显示密码" v-else class="show-pwd" @click="showPwd" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="registerForm.inviteCode" placeholder="邀请码（选填）" size="large"
              prefix-icon="el-icon-user"></el-input>
          </el-form-item>

          <div class="form-actions">
            <el-link type="primary" class="forgot-link" :underline="false">
              <router-link to="/login">已有账号？立即登录</router-link>
            </el-link>
          </div>
          <el-button type="primary" @click="handleRegister" size="large" class="login-button" block>
            注册
          </el-button>
          <div class="agreement">
            <el-checkbox v-model="registerForm.agreement" size="small">
              注册即同意 <el-link type="primary" :underline="false" size="small">隐私协议</el-link> 与 <el-link type="primary"
                :underline="false" size="small">服务条款</el-link>
            </el-checkbox>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 版权信息 -->
    <div class="copyright">
      Copyright©2023 盐城搏亿能源科技发展有限公司 备案号：<div v-html="systemParams.app_icp"></div>
    </div>
  </div>
</template>

<script>
import { phoneRules, passwordRules } from '../utils/validate'
import GetVerifyCode from '../components/GetVerifyCode.vue'
export default {
  name: 'Register',
  components: {
    GetVerifyCode
  },
  data() {
    return {
      systemParams: {},
      timer: null, // 计时器,@Function
      time: 60, // 倒计时60S,@Number
      beginning: false, // 显示倒计时,@Boolean
      registerForm: {
        phone: '',
        verifyCode: '',
        password: '',
        confirmPassword: '',
        agreement: false,
        inviteCode: ''
      },
      // 密码登录表单验证规则
      registerRules: {
        phone: phoneRules(),
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
        password: passwordRules(),
        confirmPassword: [
          ...passwordRules(), // 复用密码格式验证
          {
            validator: (rule, value, callback) => {
              // 验证两次输入的密码是否一致
              if (value !== this.registerForm.password) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback(); // 验证通过
              }
            },
            trigger: 'blur'
          }
        ]
      },
      passwordType: 'password',
    }
  },
  mounted() {
    this.getSystemParams();
  },
  methods: {
    getSystemParams() {
      this.$api.getSystemParams({}).then(res => {
        this.systemParams = res;
      }).catch(err => {
        this.$message.error(err);
      })
    },
    showPwd() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    handleRegister() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          if (!this.registerForm.agreement) return this.$message.warning('请同意隐私协议与服务条款');
          // 注册逻辑
          this.$api.register({
            mobile: this.registerForm.phone,
            code: this.registerForm.verifyCode,
            type: '1',
            password: this.registerForm.password,
            user_source: 'web',
            invite_code: this.registerForm.inviteCode
          }).then(res => {
            this.$message.success('注册成功');
            // 同时设置token和用户信息
            this.$store.dispatch('login', {
              token: res.userinfo.user_token,
              userInfo: res.userinfo
            });
            // 登录成功后跳转回原页面或首页
            const redirect = this.$route.query.redirect || '/';
            this.$router.push(redirect);
          }).catch(err => {
            this.$message.error(err);
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  /* 使用渐变背景 */
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  /* 也可以使用背景图片 */
  background-image: url('../assets/images/4.png');
  /* background-size: cover; */
  /* background-position: center; */
  /* background-repeat: no-repeat; */
}

.login-box {
  display: flex;
  width: 1082px;
  height: 608px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* 左侧插图区域 */
.login-illustration {
  position: relative;
  width: 596px;
  height: 608px;
  background-image: url('../assets/images/3.png');
  background-size: cover;
  /* background-position: center; */
}

.logo {
  position: absolute;
  top: 28px;
  left: 47px;
}

.logo img {
  /* width: 156px; */
  height: 80px;
}

/* 右侧注册表单区域 */
.login-form {
  flex: 1;
  padding: 50px 40px;
  display: flex;
  flex-direction: column;
}

.login-title {
  font-size: 20px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 30px;
}

/* 表单样式 */
.form {
  width: 100%;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 30px;
}

.remember-checkbox {
  color: #666;
  font-size: 14px;
}

.forgot-link {
  font-size: 14px;
  color: #286CED;
}

.login-button {
  height: 40px;
  font-size: 16px;
  font-weight: bold;
  border-color: #286CED;
  margin-bottom: 20px;
  width: 390px;
  height: 48px;
  background: #286CED;
  border-radius: 8px 8px 8px 8px;
}

.login-button:hover {
  background-color: #2158c7;
  border-color: #2158c7;
}

/* 协议部分 */
.agreement {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}

.agreement .el-checkbox__label {
  color: #666;
  font-size: 12px;
}

.el-link.el-link--primary {
  color: #286CED;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #286CED;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #286CED;
  border-color: #286CED;
}

.copyright {
  font-weight: 400;
  font-size: 14px;
  color: #10357B;
  margin-top: 168px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  user-select: none;
  width: 24px;
  height: 24PX;
}
</style>